// extracted by mini-css-extract-plugin
export default {"agreement":"lMfgaFFfSdp5FsD59egO"};